import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log('AdminModeController connected')
  }

  toggle(event) {
    console.log('AdminModeController toggle method called')
    const isChecked = event.target.checked
    console.log('Admin mode toggle clicked:', isChecked)
    
    // Send POST request to toggle admin mode
    const formData = new FormData()
    formData.append('admin_mode', isChecked)
    
    console.log('Sending request to /admin_mode with admin_mode:', isChecked)
    
    fetch('/admin_mode', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => {
      console.log('Response status:', response.status)
      console.log('Response ok:', response.ok)
      
      if (response.ok) {
        return response.json()
      } else {
        throw new Error(`HTTP ${response.status}`)
      }
    })
    .then(data => {
      console.log('Response data:', data)
      // Reload page to reflect admin mode changes
      window.location.reload()
    })
    .catch(error => {
      console.error('Error toggling admin mode:', error)
      // Revert checkbox if request failed
      event.target.checked = !isChecked
    })
  }
} 